import { ReactNode } from 'react';

import { Standards } from '../../../services/backendService/types';

export type UploadedFile = {
  name: string;
  fileType: string;
  uploadedFileId: string;
};

export enum Page {
  SubjectSelection = 1,
  LessonIntentSelection = 2,
  LessonGoals = 3,
  Generate = 4,
}

export type LearningGoalInputs = {
  needSupportWith?: string;
  subjectFocus?: string;
  targetSkill?: string;
  addedOwnTargetSkill?: string;
  lessonTheme?: string;
  chapter?: string;
  novel?: string;
};

export type CreateWithAIFormState = {
  prompt?: string; // Free text prompt
  grade: string;
  subject?: string; // subject coming from the standards selector
  selectedStandard?: Standards; //CCSS.ELA-LITERACY.RL.6.1
  uploadedFile?: UploadedFile; // .pdf .pptx for curify in memory file
};

export enum CreateWithAITabsEnum {
  any = 'any',
  testprep = 'testprep',
  curify = 'curify',
  vocabulary = 'vocabulary',
}
export type CreateWithAITabs = typeof CreateWithAITabsEnum[keyof typeof CreateWithAITabsEnum];

export type lessonIntent = {
  inputs: ReactNode;
  id: string;
};
